import { LinkOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Col, Row } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormNumber, useMetaSignup } from './useMetaSignup';

interface MetaIntegrationProps {
	formNumber: FormNumber;
	onFinish: (formNumber: FormNumber) => void;
	label: string;
}

export function MetaIntegration({ formNumber, onFinish, label }: MetaIntegrationProps) {
	const { whatsAppData, loading, launch } = useMetaSignup(formNumber, onFinish);

	return (
		<Row justify="center" align="middle" className="mt-4">
			<Col span={24}>
				<div style={{ width: '100%', textAlign: 'right', marginBottom: 12 }}>
					<Button
						type="link"
						onClick={() =>
							window.open(
								'https://bitrix24public.com/br24.bitrix24.com.br/docs/pub/ffd488b4c3e626f3f3110d76fed83433/default/?&',
								'_blank',
							)
						}
					>
						<LinkOutlined style={{ marginRight: -4 }} /> <FormattedMessage id="help_meta_connect" />
					</Button>
				</div>

				<div style={{ display: 'flex', justifyContent: 'center' }}>
					{!whatsAppData.picture_url || whatsAppData.picture_url === '' ? (
						<Avatar
							size={200}
							icon={<UserOutlined />}
							style={{ marginBottom: 20, marginTop: 20 }}
						/>
					) : (
						<Avatar
							size={200}
							src={whatsAppData.picture_url}
							style={{
								borderRadius: '50%',
								marginBottom: 20,
								marginTop: 20,
								objectFit: 'cover',
							}}
						/>
					)}
				</div>

				<Button
					type="primary"
					loading={loading}
					onClick={launch}
					style={{
						backgroundColor: '#1877f2',
						border: 0,
						borderRadius: 4,
						fontFamily: 'Helvetica, Arial, sans-serif',
						fontSize: 16,
						fontWeight: 'bold',
						height: 40,
						padding: '0 18px',
						width: '100%',
					}}
				>
					{label}
				</Button>
			</Col>
		</Row>
	);
}
